var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var FlagPt16 = function FlagPt16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.882 2h12.236C15.158 2 16 2.843 16 3.882v7.53c0 1.04-.843 1.882-1.882 1.882H1.882A1.882 1.882 0 0 1 0 11.412v-7.53C0 2.842.843 2 1.882 2zm0 .47c-.78 0-1.411.633-1.411 1.412v7.53c0 .78.632 1.411 1.411 1.411h12.236a1.41 1.41 0 0 0 1.411-1.411v-7.53a1.41 1.41 0 0 0-1.411-1.411H1.882z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.525 2.5v10.313H14c.828 0 1.5-.68 1.5-1.517v-7.28c0-.837-.672-1.516-1.5-1.516H5.525z",
    fill: "#EE2734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 11.296c0 .838.671 1.517 1.5 1.517h3.525V2.5H2c-.828 0-1.5.679-1.5 1.516v7.28z",
    fill: "#00924E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32 7.631c0-.985-.79-1.783-1.763-1.783-.974 0-1.764.798-1.764 1.783 0 .985.79 1.783 1.764 1.783S7.32 8.615 7.32 7.631z",
    fill: "#EE2734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85 7.63a1.3 1.3 0 0 0-1.293-1.306A1.3 1.3 0 0 0 4.264 7.63a1.3 1.3 0 0 0 1.293 1.307A1.3 1.3 0 0 0 6.85 7.631",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.557 9.916c-1.248 0-2.26-1.023-2.26-2.285 0-1.263 1.012-2.286 2.26-2.286 1.249 0 2.26 1.023 2.26 2.286 0 1.262-1.011 2.285-2.26 2.285zm0-5.139c-1.558 0-2.822 1.278-2.822 2.854 0 1.575 1.264 2.853 2.822 2.853 1.559 0 2.822-1.278 2.822-2.853 0-1.576-1.263-2.854-2.822-2.854",
    fill: "#FCFF2C"
  })));
};

FlagPt16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '16': FlagPt16
};
export var FlagPt = function FlagPt(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '16' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['16'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'FlagPt' icon. Please use one of the available sizes: '16'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};